import { PaintedScene } from '../PaintedScene';

export const THE_SLOPE_PHASER_KEY = 'TheSlopeScene' as const;
export const THE_SLOPE_MANIFEST_KEY = 's-009-the-slope' as const;

export class TheSlopeScene extends PaintedScene {
  constructor() {
    super(THE_SLOPE_PHASER_KEY, THE_SLOPE_MANIFEST_KEY);
  }
}
